<template>
  <div class="mainPage">
    <MainHeader />
    <MainSide />

    <div class="page-container">
      <!-- <transition name="route"> -->
      <router-view />
      <!-- </transition> -->

      <!-- Footer START -->
      <footer class="footer">
        <div class="footer-content">
          <p class="m-b-0 mx-auto">
            Информация© 2021 ОшГУ | Development © 2022 OshSU - IT Academy
          </p>
        </div>
      </footer>
      <!-- Footer END -->
    </div>
  </div>
</template>
<script>
import MainHeader from "../components/MainHeader.vue";
import MainSide from "../components/MainSide.vue";

export default {
  name: "Main",
  components: {
    MainHeader,
    MainSide,
  },
  data() {
    return {
      message: [],
    };
  },
};
</script>
<style lang="scss"></style>
